<script lang="ts">
  import { onMount } from 'svelte';
  import './lib_modules/vimeo-player.js';

  export let videoUrl: string;

  let videoBox: HTMLDivElement;
  let player: any;
  let isPlaying = false;
  let isHovered = false;

  const getVimeoVideoId = (url: string) => {
    const regex =
      /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/;
    const match = url.match(regex);
    return match?.[1] || null;
  };

  const videoId = getVimeoVideoId(videoUrl);
  onMount(async () => {
    if (!player) {
      const iframe = videoBox.querySelector('iframe');
      if (!iframe) return;
      player = new window.Vimeo.Player(iframe);
    }
  });
  const togglePlay = async () => {
    try {
      if (isPlaying) {
        await player.pause();
        await player.setVolume(1);
      } else {
        await player.pause();
        await player.play();
        await player.setVolume(1);
      }
      isPlaying = !isPlaying;
    } catch (error) {
      console.error('Error controlling video:', error);
    }
  };
</script>

<div class="phone-frame-wrapper" bind:this={videoBox}>
  <div class="phone-frame-inner">
    <iframe
      src="https://player.vimeo.com/video/{videoId}?background=1&autoplay=0&muted=1&autopause=1&controls=0&preload=auto"
      title="Media video player"
      frameborder="0"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    />
    <button
      class="btn vid-shoppable__btn"
      on:click={togglePlay}
      style="opacity: {!isPlaying || (isPlaying && isHovered) ? '1' : '0'}"
      on:mouseenter={() => (isHovered = true)}
      on:mouseleave={() => (isHovered = false)}
    >
      {#if !isPlaying}
        <svg
          fill="none"
          viewBox="0 0 97 97"
          class="icon icon--xxl"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.5 48.444c0-22.08 17.92-40 40-40s40 17.92 40 40-17.92 40-40 40-40-17.92-40-40Zm56 0-24-18v36l24-18Z"
            fill="#fff"
          />
        </svg>
        <span class="sr-only">Play video</span>
      {:else}
        <svg
          fill="none"
          viewBox="0 0 97 97"
          class="icon icon--xxl"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.5 48.444c0-22.08 17.92-40 40-40s40 17.92 40 40-17.92 40-40 40-40-17.92-40-40Zm20 18V30h8v36.444h-8Zm32-36.444v36.444h8V30h-8Z"
            fill="#fff"
          />
        </svg>
        <span class="sr-only">Pause video</span>
      {/if}
    </button>
  </div>
</div>

<style>
  .phone-frame-wrapper {
    position: relative;
    width: 300px;
    height: 600px;
    margin: 0 auto;
    border: 10px solid #fff;
    overflow: hidden;
    border-radius: 55px;
  }
  .phone-frame-inner:before {
    background-image: url('https://assets.voolt.com/iphone-frame.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    content: '';
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    pointer-events: none;
    opacity: 1 !important;
  }

  .phone-frame-inner iframe {
    position: absolute;
    top: 0;
    left: 5px;
    bottom: 0;
    right: 5px;
    width: 100%;
    height: 100%;
    transform: scale(1.2);
    z-index: -1;
  }

  .vid-shoppable__btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 3;
    transition:
      opacity 0.2s ease,
      transform 0.2s ease;
  }

  .vid-shoppable__btn:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  .icon--xxl {
    width: 97px;
    height: 97px;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
</style>
